import React, { useState, useRef } from 'react';
import { ReactComponent as CloudUploadIcon } from '../assets/Cloud_Upload.svg';

function FileUpload({ isLoading, handleUpload }) {
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.type === 'application/pdf') {
        // Create a fake form event to maintain compatibility
        const fakeEvent = {
          preventDefault: () => {},
          target: {
            elements: {
              file: { files: [file] }
            }
          }
        };
        handleUpload(fakeEvent);
      } else {
        alert('Please upload only PDF files.');
      }
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      handleUpload(e);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleUpload(e);
  };

  return (
    <div className="upload-section">
      <div className="upload-form">
        <h3 className="font-medium text-xl">Upload PDF</h3>
        
        <div 
          className={`upload-dropzone ${isDragOver ? 'drag-over' : ''} ${isLoading ? 'loading' : ''}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleClick}
        >
          <CloudUploadIcon className="upload-icon" />
          <div className="upload-text">
            <p className="upload-primary-text">
              {isLoading ? 'Uploading...' : 'Drop your PDF here or click to browse'}
            </p>
            <p className="upload-secondary-text">
              PDF files only
            </p>
          </div>
          
          <form onSubmit={handleFormSubmit} style={{ display: 'none' }}>
            <input 
              ref={fileInputRef}
              type="file" 
              name="file" 
              accept=".pdf" 
              required 
              onChange={handleFileChange}
            />
          </form>
        </div>
      </div>
      
      <div className="upload-info">
        <p>💡 <strong>Google Drive integration</strong> will be available after backend OAuth setup</p>
      </div>
    </div>
  );
}

export default FileUpload; 